import { render, staticRenderFns } from "./DialogReverse.vue?vue&type=template&id=56294520"
import script from "./DialogReverse.vue?vue&type=script&lang=js"
export * from "./DialogReverse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports